import { getUserEmail, InfoBox, useUser, useFeatureIsEnabled } from "@desp-aas/desp-ui-fwk";
import { ReactNode } from "react";
import { NavLink } from "react-router-dom";


type IProps = {
    message?: ReactNode
}

export const EmailRequiredInfoBox = (props: IProps) => {
    const user = useUser();
    const isEmailEnabled = useFeatureIsEnabled("email_enabled");
    
    if(getUserEmail(user) || !isEmailEnabled){
        return null;
    }

    return (
        <InfoBox
            title="Information"
            type="warn"
            small
        >
            {props.message || "Email required to continue."} <NavLink to="/user/profile">Register email here</NavLink>.
        </InfoBox>
    )
}